import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_71: FaireProductEntity = {
  token: "catalog_prod_prod-71",
  type: "product",
  name: "Curved Base Table Lamp with Pleated Shade - Style 3",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?w=400&h=400&fit=crop",
  priceDollars: 80.83,
  msrpDollars: 202.08,
  sku: "JA0071",
  caseSize: 2,
  material: "Glass",
  collectionToken: "col_japandi",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 136,
  description: "Beautiful Japandi piece perfect for any home.",
  categoryTokens: ["catalog_cat_bath-body"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
